// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__0a-dQ","image":"Preloader_image__gahVg"};